<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="rtProcess"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工序编号">
            <el-input v-model.trim="filter.processNo" placeholder="请输入工序编号" clearable/>
          </el-form-item>
          <el-form-item label="工序名称">
            <el-input v-model.trim="filter.processName" placeholder="请输入工序名称" clearable/>
          </el-form-item>
          <el-form-item label="工序类型">
            <el-select v-model="filter.processType" placeholder="请选择工序类型" clearable>
              <el-option v-for="item in processTypeList" :key="item.pkid" :label="item.processTypeName"
                         :value="item.pkid"/>
            </el-select>
          </el-form-item>
          <el-form-item label="工序状态">
            <el-select v-model="filter.status" placeholder="请选择工序状态" clearable>
              <el-option label="未确认" :value="0"/>
              <el-option label="已确认" :value="1"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>

      <template slot="actionBtn" slot-scope="scope">
        <el-button type="primary" @click="$refs.procedureEdit.open(scope.row, 1)">详情</el-button>
      </template>
    </viewTable>
    <procedure-edit ref="procedureEdit" :process-type-list="processTypeList" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ProcedureEdit from "./ProcedureEdit";

  export default {
    name: "ProcedureList",
    components: {viewTable, ProcedureEdit},
    data() {
      return {
        limits: {
          addAuth: this.$auth(206),
          editAuth: this.$auth(208),
          delAuth: this.$auth(210),
        },
        filter: {
          processNo: "",
          processName: "",
          processType: "",
          status: "",
        },
        processTypeList: [],
        columnsProperty: [
          {
            key: "processNo",
            width: 100,
            align: "center",
          },
          {
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            key: "note",
            minWidth: 150,
            tooltip: true,
          },
          {
            key: "processTypeName",
            minWidth: 150,
            tooltip: true,
          },
          {
            key: "processName",
            minWidth: 150,
            tooltip: true,
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    mounted() {
      this.getProcessType();
    },

    methods: {
      // 新增、编辑
      addEditHandle(row) {
        this.$refs.procedureEdit.open(row);
      },

      // 加载数据
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "rtProcess", row.pkid).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      getProcessType() {
        this.$http.get("basic", "rtProcess/selectorItems").then((res) => {
          if (res.success) {
            this.processTypeList = res.data;
          }
        });
      },
    },
  };
</script>
